import { useState } from "react"
import NewProductForm from "./NewProductForm"

function NewProductModal({ setProducts, categories }) {
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "success", // success | danger
  })

  /* =========================
     SHOW TOAST
  ========================= */
  const showToast = (message, type = "success") => {
    setToast({ show: true, message, type })

    setTimeout(() => {
      setToast((prev) => ({ ...prev, show: false }))
    }, 3000)
  }

  /* =========================
     HANDLE SUCCESS
  ========================= */
  const handleSuccess = () => {
    showToast("Successfully added new product!", "success")

    // Close modal (Bootstrap way)
    const modal = document.getElementById("newProductModal")
    const closeBtn = modal?.querySelector(".btn-close")
    closeBtn?.click()
  }

  /* =========================
     HANDLE ERROR
  ========================= */
  const handleError = () => {
    showToast("Failed to add product. Try again.", "danger")
  }

  return (
    <>
      {/* =========================
          MODAL
      ========================= */}
      <div
        className="modal fade"
        id="newProductModal"
        tabIndex="-1"
        aria-labelledby="newProductModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen-xl-down modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-3 ms-2">Create New Product</h1>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            <div className="modal-body">
              <div className="container-fluid">
                <NewProductForm
                  setProducts={setProducts}
                  categories={categories}
                  onSuccess={handleSuccess}
                  onError={handleError}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =========================
          TOAST (BOTTOM RIGHT)
      ========================= */}
      <div
        className="position-fixed bottom-0 end-0 p-3"
        style={{ zIndex: 9999 }}
      >
        <div
          className={`toast align-items-center text-bg-${toast.type} border-0 ${
            toast.show ? "show" : "hide"
          }`}
        >
          <div className="d-flex">
            <div className="toast-body">{toast.message}</div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setToast((prev) => ({ ...prev, show: false }))}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default NewProductModal
